// removed by extract-text-webpack-plugin
module.exports = {"deck-grid":"_3ItqKChttyPTqWPNQzfWjN"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/components/DeckGrid.styl
// module id = 503
// module chunks = 0